import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { CcStateSettingsType } from "client/utils"
import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    DivInput,
    UserIcon,
} from "client/components"

const Details = () => {
    const item = useSelector((state: StoreType) => state.ccReviewReview.itemDetails)
    const itemState = useSelector((state: StoreType) => state.ccReviewReview.itemState)

    const levelList = useSelector((state: StoreType) => state.ccApprovalLevel.levelList)
    const moduleLevelList = useSelector((state: StoreType) => state.ccApprovalLevel.moduleLevelList)
    const levelIds = moduleLevelList[2] || [] // review level ids

    const typeList = useSelector((state: StoreType) => state.ccReviewReviewType.typeList)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const firstLevelId = levelIds.length ? levelIds[0] : null
    const firstLevel = firstLevelId
        ? levelList[firstLevelId]
        : null

    const settings: CcStateSettingsType = itemState && itemState.settings ? JSON.parse(itemState.settings) : {}
    const userId = settings[firstLevelId]

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.reviewItem}</Label>
                        <Textarea value={item.remark} readOnly />
                    </FormGroup>

                    <Row>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>{lang.seePage}</Label>
                                <Input type="text" value={item.page} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>{lang.kind}</Label>
                                <Input type="text" value={typeList[item.typeId] ? typeList[item.typeId].name : ""} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={firstLevel ? 6 : 12}>
                            <FormGroup>
                                <Label>{lang.revision}</Label>
                                <Input type="text" value={item.version ? item.version.revision : ""} readOnly />
                            </FormGroup>
                        </Col>
                        {
                            firstLevel && (
                                <Col xs={6}>
                                    <FormGroup>
                                        <Label>{firstLevel.name}</Label>
                                        <DivInput><UserIcon user={userList[userId]} size="sm" /></DivInput>
                                    </FormGroup>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Details
